import axios from "axios";

const debugMode = import.meta.env.VITE_DEBUG_MODE === "1";
console.log("isDebugMode===========:" + debugMode);
// 创建axios实例
const service = axios.create({
  baseURL: import.meta.env.VITE_BASE_API,
  timeout: 10000,
});

// request拦截器
service.interceptors.request.use(
  (config) => {
    // 取的裝置資訊
    var device = "web";

    // 取得登入資訊
    const access_token = localStorage.getItem("access_token");
    const open_id = localStorage.getItem("open_id");
    const uuid = localStorage.getItem("uuid");
    const refresh_token = localStorage.getItem("refresh_token");
    const uuid_date = localStorage.getItem("uuid_date");

    if (undefined != access_token && "" != access_token) {
      config.headers["Authorization"] = "Bearer " + access_token;
      config.headers["open_id"] = open_id;
      config.headers["uuid"] = uuid;
      config.headers["refresh_token"] = refresh_token;
      config.headers["uuid_date"] = uuid_date;
      config.headers["device"] = device;
      config.headers["Accept"] = "application/json";
    }

    return config;
  },
  (error) => {
    // Do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

// respone拦截器
service.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    // 將錯誤訊息回傳
    console.log(error.response);
    return error.response.data;
  }
);

export default service;
